"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recipientActionLabels = void 0;

var _messaging = require("./messaging.types");

var recipientActionLabels = {
  [_messaging.RecipientActionsFields.CaptureDate]: 'Accept a calendar invite',
  [_messaging.RecipientActionsFields.CapturePhone]: 'Provide phone number',
  [_messaging.RecipientActionsFields.CaptureEmail]: 'Provide email address',
  [_messaging.RecipientActionsFields.CaptureQuestion]: 'Answer custom questions',
  [_messaging.RecipientActionsFields.CaptureAffidavit]: 'Accept custom terms & conditions'
};
exports.recipientActionLabels = recipientActionLabels;